/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassAttendanceDTO,
  ClassAttendanceDTOOptional,
  ClassAttendanceDTOMetaI,
  ClassAttendanceDTOTrackedI,
} from "./class-attendance-dto";
import {
  ClassAttendanceDTOTracked,
  ClassAttendanceDTOMeta,
} from "./class-attendance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSessionDTO,
  ClassSessionDTOOptional,
  ClassSessionDTOMetaI,
  ClassSessionDTOTrackedI,
} from "./class-session-dto";
import {
  ClassSessionDTOTracked,
  ClassSessionDTOMeta,
} from "./class-session-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionInternal,
  UnifiedClassSessionInternalOptional,
  UnifiedClassSessionInternalMetaI,
  UnifiedClassSessionInternalTrackedI,
} from "./unified-class-session-internal";
import {
  UnifiedClassSessionInternalTracked,
  UnifiedClassSessionInternalMeta,
} from "./unified-class-session-internal";

/**
 *
 * @export
 * @interface ClassSessionInternalDTO
 */
export interface ClassSessionInternalDTOOptional extends ClassSessionDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSessionInternalDTO
   */
  instanceId?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {Array<ClassAttendanceDTO>}
   * @memberof ClassSessionInternalDTO
   */
  attendance?: ClassAttendanceDTOOptional[];
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  endDatetime?: Date;
}

export interface ClassSessionInternalDTO
  extends
    ClassSessionInternalDTOOptional,
    ClassSessionDTO,
    Deletable,
    UnifiedClassSessionInternal {
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSessionInternalDTO
   */
  instanceId?: UnifiedClassInstanceRef;
  /**
   *
   * @type {Array<ClassAttendanceDTO>}
   * @memberof ClassSessionInternalDTO
   */
  attendance?: ClassAttendanceDTO[];
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  endDatetime?: Date;
}

export interface ClassSessionInternalDTOTrackedI extends ClassSessionDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  sessionDatetime?: Date;
  sessionDatetimeIsSet: boolean;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSessionInternalDTO
   */
  instanceId?: UnifiedClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {Array<ClassAttendanceDTO>}
   * @memberof ClassSessionInternalDTO
   */
  attendance?: ClassAttendanceDTOTrackedI[];
  attendanceIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSessionInternalDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSessionInternalDTO
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSessionInternalDTO
   */
  endDatetime?: Date;
  endDatetimeIsSet: boolean;
}

transformDatesMap.set(
  "ClassSessionInternalDTO",
  function (model: ClassSessionInternalDTO) {
    if (typeof model.sessionDatetime == "string")
      model.sessionDatetime = new Date(model.sessionDatetime);
    const transformDatesinstanceId = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDatesattendance =
      transformDatesMap.get("ClassAttendanceDTO");
    if (transformDatesattendance) {
      model.attendance?.forEach((sub) => {
        transformDatesattendance(sub);
      });
    }
    if (typeof model.cancelledDatetime == "string")
      model.cancelledDatetime = new Date(model.cancelledDatetime);
    if (typeof model.endDatetime == "string")
      model.endDatetime = new Date(model.endDatetime);
  },
);

export type ClassSessionInternalDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  sessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  attendance: PropertyMeta<ClassAttendanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endDatetime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var ClassSessionInternalDTOMeta: ClassSessionInternalDTOMetaI =
  {} as ClassSessionInternalDTOMetaI;
ClassSessionInternalDTOMeta = typeMeta("ClassSessionInternalDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  sessionDatetime: propertyMeta(
    "sessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  attendance: propertyMeta(
    "attendance",
    true,
    false,
    false,
    ClassAttendanceDTOMeta,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endDatetime: propertyMeta(
    "endDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = ClassSessionInternalDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSessionInternalMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSessionInternalMeta.assignId;
  metaI.sessionDatetime.inheritedFrom =
    UnifiedClassSessionInternalMeta.sessionDatetime;
  metaI.instanceId.inheritedFrom = UnifiedClassSessionInternalMeta.instanceId;
  metaI.attendance.inheritedFrom = UnifiedClassSessionInternalMeta.attendance;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([ClassSessionDTOMeta]);
  metaI.assignId.inheritedFrom = ClassSessionDTOMeta.assignId;
  metaI.sessionDatetime.inheritedFrom = ClassSessionDTOMeta.sessionDatetime;
  metaI.sessionLength.inheritedFrom = ClassSessionDTOMeta.sessionLength;
  metaI.cancelledDatetime.inheritedFrom = ClassSessionDTOMeta.cancelledDatetime;
  metaI.endDatetime.inheritedFrom = ClassSessionDTOMeta.endDatetime;
});

export class ClassSessionInternalDTOTracked
  extends ClassSessionDTOTracked
  implements ClassSessionInternalDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  sessionDatetime__I?: Date = undefined;
  sessionDatetimeIsSet: boolean = false;
  set sessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sessionDatetime__I = v;
      this.sessionDatetimeIsSet = true;
    } else {
      this.sessionDatetime__I = v || undefined;
      this.sessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDatetime() {
    return this.sessionDatetime__I;
  }
  instanceId__I?: UnifiedClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  attendance__I?: ClassAttendanceDTOTracked[] = undefined;
  attendanceIsSet: boolean = false;
  set attendance(v: undefined | ClassAttendanceDTOTracked[]) {
    if (v !== undefined) {
      this.attendance__I = v;
      this.attendanceIsSet = true;
    } else {
      this.attendance__I = v || undefined;
      this.attendanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get attendance() {
    return this.attendance__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  endDatetime__I?: Date = undefined;
  endDatetimeIsSet: boolean = false;
  set endDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.endDatetime__I = v;
      this.endDatetimeIsSet = true;
    } else {
      this.endDatetime__I = v || undefined;
      this.endDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get endDatetime() {
    return this.endDatetime__I;
  }
  constructor(
    config?: ClassSessionInternalDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.instanceId?.setIds();

    this.attendance?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: ClassSessionInternalDTOOptional,
    options?: AssignOptions,
  ): ClassSessionInternalDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.sessionDatetime &&
      this.sessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDatetime = config.sessionDatetime;
      if (optionsRequired.unassign) this.sessionDatetimeIsSet = false;
      else this.sessionDatetimeIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new UnifiedClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.attendance &&
      this.attendanceApplyFilter(optionsRequired.filter)
    ) {
      this.attendance = config.attendance?.map(
        (a) => new ClassAttendanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.attendanceIsSet = false;
      else this.attendanceIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (
      config.endDatetime &&
      this.endDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.endDatetime = config.endDatetime;
      if (optionsRequired.unassign) this.endDatetimeIsSet = false;
      else this.endDatetimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSessionInternalDTOTrackedI {
    const cloned = {} as ClassSessionInternalDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.sessionDatetimeIsSetDeep() &&
      this.sessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatetimeIsSet = true;
      cloned.sessionDatetime = this.sessionDatetime;
    } else {
      //cloned.sessionDatetimeIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.attendanceIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.attendanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendanceIsSet = true;
      cloned.attendance = this.attendance
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.attendanceIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    if (
      this.endDatetimeIsSetDeep() &&
      this.endDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endDatetimeIsSet = true;
      cloned.endDatetime = this.endDatetime;
    } else {
      //cloned.endDatetimeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSessionInternalDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.sessionDatetimeApplyFilter(filter))
      this.sessionDatetimeIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.attendanceApplyFilter(filter)) this.attendanceIsSet = false;

    this.attendance?.forEach((a) => a.unassignAll(filter));
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    if (!this.endDatetimeApplyFilter(filter)) this.endDatetimeIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.assignId,
      ClassSessionInternalDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  sessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.sessionDatetime,
      ClassSessionInternalDTOMeta,
      this.sessionDatetime,
      this,
    );
  }
  sessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatetimeIsSet && this.sessionDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.instanceId,
      ClassSessionInternalDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  attendanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.attendance,
      ClassSessionInternalDTOMeta,
      this.attendance,
      this,
    );
  }
  attendanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendanceIsSet && this.attendanceApplyFilter(filter)) return true;

    return this.attendance?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.isDeleted,
      ClassSessionInternalDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.isNew,
      ClassSessionInternalDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.sessionLength,
      ClassSessionInternalDTOMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.cancelledDatetime,
      ClassSessionInternalDTOMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  endDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSessionInternalDTOMeta.endDatetime,
      ClassSessionInternalDTOMeta,
      this.endDatetime,
      this,
    );
  }
  endDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endDatetimeIsSet && this.endDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.sessionDatetimeIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.attendanceIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    if (this.endDatetimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
